import FilterContainer from './FilterContainerWrapper';
export { FilterContainer as GlobalFilters };
//# sourceMappingURL=GlobalFilters.js.map